import styled from 'styled-components';

export const IconWrapper = styled.div`
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 100px;
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UserInitial = styled.span`
  
`;